import React from "react";
import { Phone } from "@reverb-ui/icons-react";
import { Button, Flex, Text } from "@reverb-ui/react";
import { FlexLine } from "../company-owner/flex-line";
import { ContactTable } from "./contact-table";
import { useTranslation } from "react-i18next";
export var CompanyOwnerContact = function (_a) {
    var clientContacts = _a.clientContacts, toggleModalContactVisibility = _a.toggleModalContactVisibility;
    var t = useTranslation("my-account").t;
    return (React.createElement(Flex, { direction: "column", alignItems: "flex-start", p: "0", w: "full" },
        React.createElement(Flex, { direction: "row", alignItems: "center", justifyContent: "start", p: "0", w: "full", mb: "24px" },
            React.createElement(Phone, { color: "gray.400" }),
            React.createElement(Text, { fontSize: "xl", color: "gray.800", ml: "13px" },
                React.createElement("b", null, t("company-tab.contact")))),
        React.createElement(Flex, { direction: "row", alignItems: "flex-start", p: "0", w: "full", mb: "24px" }, clientContacts && React.createElement(ContactTable, { contacts: clientContacts })),
        React.createElement(FlexLine, { justifyContent: "flex-end" },
            React.createElement(Button, { variant: "outline", onClick: function () { return toggleModalContactVisibility(); } }, t("company-tab.edit-contacts")))));
};
